import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { extend } from 'lodash';

export default class PillList extends PureComponent {
    static propTypes = {
        items: PropTypes.array.isRequired,
        onRemoveItem: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        extra: PropTypes.object,
        visibleItemCount: PropTypes.number,
        className: PropTypes.string
    };

    static defaultProps = {
        visibleItemCount: -1,
        showAll: true,
        onRemoveItem: null,
        className: ""
    };

    constructor(props) {
        super(props);

        this.state = { showAll: this.visibleItemCount === -1 };

        this.toggleShowAll = this.toggleShowAll.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }

    toggleShowAll = () => { this.setState({ showAll: !this.state.showAll }); };

    removeItem = (item) => { this.props.onRemoveItem && this.props.onRemoveItem(item) };
    //removeItem = (item) => { this.props.onRemoveItem(this.props.items.filter(i => i !== item), this.props.extra) }

    renderShowMore = () =>
        <span onClick={this.toggleShowAll} className={'toggle'}>
            {this.state.showAll ?
                <FormattedMessage id={"General_CoreFunctionality_UIText_seeLess"}/> :
                <FormattedMessage id={"General_CoreFunctionality_UIText_seeMore"}/>
            }
        </span>;

    render() {
        const isTrimmed = this.props.visibleItemCount !== -1 && this.props.items.length > this.props.visibleItemCount;
        const items = isTrimmed && !this.state.showAll ? this.props.items.slice(0, this.props.visibleItemCount) : this.props.items;

        return (
            <div className={"pill-list " + this.props.className}>
                {items.map((item, key) =>
                    <PillItem item={item} key={key} onRemove={this.props.onRemoveItem && this.removeItem}/>)}
                {isTrimmed && this.renderShowMore()}
            </div>
        )
    }
}

export class StaticPillList extends PillList {
    static propTypes = extend({}, PillList.propTypes, {
        totalCount: PropTypes.number,
        onShowMore: PropTypes.func
    });

    renderShowMore = () => <span onClick={this.props.onShowMore} className={'toggle'}>
        <FormattedMessage id={"General_CoreFunctionality_UIText_seeMoreNumber"} values={{ number: this.props.totalCount }}/>
    </span>;
}

export const PillItem = ({ item, onRemove = null }) => {
    function handleRemove() { onRemove(item) }

    return item && <span className={"tags-label notranslate " + (onRemove ? "" : "readonly") } title={item.label}>
        {item.label}
        {onRemove && <span className="tags-label__close-button la-CloseRemove" onClick={handleRemove} />}
    </span>;
};



// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/PillList.jsx